import * as THREE from 'three';

import type { POCVersion, ThreeContext } from '~/clinic-inside/useClinic3d';

import type { ContentSceneFragment } from '#gql';
import { Vector3 } from 'three';
import gsap from 'gsap';
import { useModel } from '~/clinic-inside/utils/useModel';

export function useClinicModel(
  context: ThreeContext,
  version: POCVersion,
  content: ContentSceneFragment[],
) {
  const clinic = useModel(context.scene, version);
  const { isVl } = useViewportSize();

  if (isVl.value) {
    for (let i = 0; i < content.length; i++) {
      const c = content[i];

      const titleRoom1 = context.text3d.getText(String(c.title), 24, 'md');
      titleRoom1.name = c.title as string;
      titleRoom1.position.z = 4.2 - i * 14.1;
      alignTextGroup(titleRoom1, 'center');
      context.scene.add(titleRoom1);
      titleRoom1.userData.toggleVisibleTimeline = { play: () => {} };
      titleRoom1.userData.toggleVisibleTimeline.play = (visible: boolean) => {
        for (let j = 0; j < titleRoom1.children.length; j++) {
          const child = titleRoom1.children[j] as THREE.Mesh;
          gsap.fromTo(
            child.material,
            {
              opacity: visible ? 0 : 1,
            },
            {
              opacity: visible ? 1 : 0,
              duration: 0.5,
              ease: 'power2.inOut',
            },
          );
        }
      };
      const visibleAtStart = i === 0;
      context.addVisibilityObject(
        titleRoom1,
        0,
        { front: -2, back: -5 },
        visibleAtStart,
      );
      const copyRoom1 = context.text3d.getText(String(c.copy), 40, 'sm');
      copyRoom1.position.z = 0.9 - i * 14.1;
      copyRoom1.name = c.copy as string;
      copyRoom1.userData.toggleVisibleTimeline = { play: () => {} };
      copyRoom1.userData.toggleVisibleTimeline.play = (visible: boolean) => {
        for (let j = 0; j < copyRoom1.children.length; j++) {
          const child = copyRoom1.children[j] as THREE.Mesh;
          gsap.fromTo(
            child.material,
            {
              opacity: visible ? 0 : 1,
            },
            {
              opacity: visible ? 1 : 0,
              duration: 0.5,
              ease: 'power2.inOut',
            },
          );
        }
      };
      if (i !== 2) {
        alignTextGroup(copyRoom1, i === 4 ? 'left' : 'center');
      }
      context.scene.add(copyRoom1);
      context.addVisibilityObject(copyRoom1, 0, { front: -1, back: -4 });
    }
  }

  function alignTextGroup(textGroup: THREE.Group, align: 'center' | 'left') {
    const bbox = new THREE.Box3().setFromObject(textGroup);
    const size = new Vector3();
    bbox.getSize(size);
    if (align === 'center') {
      textGroup.position.x -= size.x / 2;
    } else {
      textGroup.position.x -= size.x;
    }
  }

  return clinic;
}
